import React from 'react';
import WarningIcon from '../../../../assets/images/warning-icon.svg';
import styles from './addproduct.module.scss';
import { Button } from 'reactstrap';
import Proptypes from 'prop-types';

const EPCWarningModal = ({ handleSubmit, toggle }) => {
  return (
    <div className={styles['success_container']}>
      <img src={WarningIcon} alt="succes" width={102} height={102} />
      <div
        style={{
          marginTop: '24px',
          marginBottom: '14px',
        }}
      >
        <p className={styles['success_heading']}>Custom EPC Warning</p>
      </div>
      <div
        style={{
          marginBottom: '20px',
        }}
      >
        <p className={styles['added_label']}>
          Does your product have a Global Trade Item Number (GTIN)? Your tags will work fine without
          one, but you can&apos;t edit the GTIN later.
        </p>
      </div>

      <div className={styles['epc_warning_buttons_container']}>
        <div>
          <Button
            className={`${styles['button_cancel']} ${styles['steptwothree_buttons_layout']}`}
            onClick={toggle}
          >
            Cancel
          </Button>
        </div>
        <div>
          <Button
            className={`${styles['button_active']} ${styles['steptwothree_buttons_layout']}`}
            onClick={() => {
              handleSubmit();
            }}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

EPCWarningModal.propTypes = {
  handleSubmit: Proptypes.func,
  toggle: Proptypes.func,
};

export default EPCWarningModal;
